<template>
  <fragment>
    <beneficiario-header @sair="sair()"></beneficiario-header>
    <beneficiario-modal
      :titulo="dadosModal.titulo"
      :conteudo="dadosModal.texto"
      :show="modalShow"
      @close="modalShow = false"
      clickOut
    ></beneficiario-modal>
    <beneficiario-modal
      titulo="Hospital Unimed veja nossos serviços ativados"
      :imagem="imgPopUp"
      :show="popup"
      @close="popup = false"
      clickOut
    ></beneficiario-modal>
    <div
      id="ex1"
      class="modal"
    >
      <div class="conteudo-modal">
        <div class="dados-modal" />
      </div>
    </div>
    <main class="home--container">
      <div class="bolinha" />

      <div class="linha-1" />

      <div class="linha-2" />

      <div class="bolinha bolinha-clean" />
      <div class="central">
        <div class="servicos">
          <h2 class="titulo-servicos">Atendimento</h2>

          <div class="imagem-central">
            <img
              class="imagem-redonda"
              src="https://firebasestorage.googleapis.com/v0/b/unimed-a36d6.appspot.com/o/unimed-aviao.jpg?alt=media&token=e9b6625f-9304-4575-8c24-42b14eab1849"
              alt="aviao"
            />
          </div>
          <div class="texto-central">
            <p>
              Unidades próprias, rede completa de serviços, produtos
              personalizados, canais de relacionamento 24 horas. A Unimed
              Juiz de Fora está sempre por perto. Conte conosco!
            </p>
          </div>
        </div>
        <div class="servicos">
          <h2 class="titulo-servicos">Centros Especializados</h2>

          <div class="imagem-central">
            <img
              class="imagem-redonda"
              src="https://firebasestorage.googleapis.com/v0/b/unimed-a36d6.appspot.com/o/centros-especializados.png?alt=media&token=26b1e02f-a1bb-4358-b1be-6158d26e47a7"
              alt="centros"
            />
          </div>
          <div class="texto-central">
            <p>
              Equipes multidisciplinares atuando em unidades dedicadas ao
              cuidado integral, prevenção, apoio continuado, terapias,
              medicina paliativa e assistência a necessidades especiais.
            </p>
          </div>
        </div>
        <div class="servicos">
          <h2 class="titulo-servicos">Espaço Viver Bem</h2>

          <div class="imagem-central">
            <img
              class="imagem-redonda"
              src="https://firebasestorage.googleapis.com/v0/b/unimed-a36d6.appspot.com/o/Espaco-Viver-Bem.png?alt=media&token=b015303f-f26a-4007-b0f3-1ffc0320e38c"
              alt="espaco"
            />
          </div>
          <div class="texto-central">
            <p>
              Programas de atenção à saúde e acompanhamento individualizado,
              totalmente gratuitos, para prevenir doenças ou apoiar o
              tratamento, até que seja restabelecido o bem-estar do
              paciente.
            </p>
          </div>
        </div>
      </div>

      <div class="conteudos">
        <beneficiario-grid
          :dados="dados"
          @open="dadosModal = $event"
        />
      </div>
      <div class="cartilha">
        <a
          href="http://www.unimedjf.coop.br/acesso-beneficiario/static/media/Cartilha_UFJF_2019.6d2a9e74.pdf"
          class="btn-download"
          target="_blank"
        >Baixe aqui sua cartilha</a>
      </div>
      <div class="localizacao">
        <div class="titulo-localizacao">Unidade mais próxima</div>

        <div id="conteudo-localizacao">
          <div id="map">
            <google-maps></google-maps>
          </div>
        </div>
      </div>
    </main>
  </fragment>
</template>

<script>
import Header from './layout/Beneficiario-Header.vue';
import Grid from './components/Beneficiario-Grid.vue';
import Maps from './components/GoogleMaps.vue';
import Modal from './components/Modal.vue';
import { conteudo } from '@/api/beneficiarioApi';
import imgPopUp from '../../assets/images/emergencia.jpg';

import './style/error.css';
import './style/site.css';

export default {
  components: {
    'beneficiario-header': Header,
    'beneficiario-grid': Grid,
    'google-maps': Maps,
    'beneficiario-modal': Modal,
  },
  data() {
    return {
      dados: [],
      modalShow: false,
      popup: true,
      imgPopUp,
      dadosModal: {
        titulo: '',
        texto: '',
      },
    };
  },
  watch: {
    dadosModal() {
      this.modalShow = true;
    },
  },
  mounted() {
    this.loadSession();
    document.title = 'Index';
  },
  methods: {
    async loadSession() {
      const empresa = sessionStorage.getItem('empresa');
      if (empresa) {
        const result = await conteudo(empresa);
        this.dados = result;
      } else {
        this.$router.push({ path: '/login' });
      }
    },
    sair() {
      sessionStorage.setItem('empresa', '');
      this.$router.push({ path: '/login' });
    },
  },

};
</script>

<style scoped>
.btn-download {
  color: #ffffff;
}
</style>
